<template>
  <app-layout>
    <dashboard-layout>
      <template slot="header">
        <v-menu offset-y>
          <v-btn color="primary" slot="activator">{{ $t('Ejercicio') }}: {{ year }}</v-btn>
          <v-list>
            <v-list-tile v-for="y in years" :key="y" @click="year = y">
              <v-list-tile-title>{{ y }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </template>
      <template slot="footer-row">
        <og-laboral-documents :key="year" :year="year"></og-laboral-documents>
      </template>
      <template slot="sidebar">
        <v-flex md12>
          <my-consultant-conversation></my-consultant-conversation>
        </v-flex>
        <v-flex md12 pt-3>
          <calendar-events></calendar-events>
        </v-flex>
      </template>
    </dashboard-layout>
    <router-view></router-view>
  </app-layout>
</template>

<script>
import AppLayout from '@/views/layouts/AppLayout.vue';
import DashboardLayout from '@/views/layouts/DashboardLayout.vue';
import MyConsultantConversation from '@/modules/myconsultant/components/threads/MyConsultantConversation.vue';
import CalendarEvents from '@/modules/calendar/components/CalendarEvents.vue';
import OgLaboralDocuments from '../components/fiscal-obligations/OgLaboralDocuments.vue';
import apiCtrl from '@/services/api/abstract/abstract-api.js';

export default {
  components: {
    AppLayout,
    CalendarEvents,
    MyConsultantConversation,
    DashboardLayout,
    OgLaboralDocuments,
  },

  data: () => ({
    year: 2024,
    years: [2020, 2021, 2022, 2023, 2024],
  }),
  mounted() {
    this.markDocNotificationsAsReaded('Laboral');
    this.setInitialYear();
  },

  methods: {
    setInitialYear() {
      const date = new Date();
      date.setMonth(date.getMonth() - 1);
      const year = date.getFullYear();
      this.year = year;
    },
    markDocNotificationsAsReaded(category) {
      const body = {
        category: category,
      };
      apiCtrl.post('/document-notification/mark-as-readed', body).then(res => {
        // console.log(res);
      });
    },
  },
};
</script>
